import "../assets/Input.css";
import { h as V, defineComponent as C, useCssVars as M, unref as m, ref as f, computed as B, openBlock as v, createElementBlock as k, createVNode as E, createElementVNode as p, toDisplayString as R, withDirectives as q, vModelDynamic as x, createBlock as D, createCommentVNode as L } from "vue";
import { _ as N } from "./Tooltip.vue_vue_type_style_index_0_lang.DpTgOQlz.js";
import { e as T } from "./useStore.D00eUhpv.js";
const z = (n, s) => {
  const d = "http://www.w3.org/2000/svg", o = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 21" fill="currentColor">
  <path fill-rule="evenodd" d="M6.843 3.211a8.25 8.25 0 116.314 15.244A8.25 8.25 0 016.843 3.211zM10 4.083a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zM7.803 8.636a.75.75 0 011.06 0L10 9.772l1.136-1.136a.75.75 0 011.061 1.06l-1.136 1.137 1.136 1.136a.75.75 0 01-1.06 1.061L10 11.894 8.864 13.03a.75.75 0 11-1.061-1.06l1.136-1.137-1.136-1.136a.75.75 0 010-1.061z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (n.title) {
    const t = document.createElementNS(d, "title");
    t.textContent = n.title, o.appendChild(t);
  }
  const r = Array.from((o == null ? void 0 : o.attributes) ?? []).reduce((t, l) => ({
    ...t,
    [l.name]: l.value
  }));
  return V(
    "svg",
    {
      ...r,
      ...s.attrs,
      role: "img",
      innerHTML: o.innerHTML
    }
  );
}, A = {
  class: "thn--tool-input",
  ref: "rootRef"
}, S = ["for"], H = { class: "relative w-full" }, P = ["required", "disabled", "type", "name", "id", "error", "placeholder", "aria-label"], h = 10, X = /* @__PURE__ */ C({
  __name: "Input",
  props: {
    placeholder: { default: "" },
    type: {},
    errorMessage: { default: "" },
    required: { type: Boolean },
    disabled: { type: Boolean },
    modelValue: {},
    id: {}
  },
  emits: ["update:modelValue"],
  setup(n, { expose: s, emit: d }) {
    M((e) => ({
      d5825cb0: m(T)(h)
    }));
    const u = n, o = d, r = f(), t = f(), l = B({
      get: () => u.modelValue,
      set: (e) => {
        o("update:modelValue", e);
      }
    });
    function g() {
      t.value.hide();
    }
    function w() {
      var a;
      const {
        top: e,
        left: i
      } = ((a = r.value) == null ? void 0 : a.getBoundingClientRect()) || {};
      t.value.show(u.errorMessage, {
        top: e,
        left: i + h
      });
    }
    function y() {
      const e = r.value.validity.valid;
      return e || w(), e;
    }
    function b() {
      r.value.value = "";
    }
    return s({
      clear: b,
      validate: y
    }), (e, i) => {
      var a, c;
      return v(), k("div", A, [
        E(N, {
          ref_key: "errorTooltipRef",
          ref: t,
          "auto-hide": 3e3
        }, null, 512),
        p("label", {
          class: "sr-only",
          for: e.id
        }, R(e.placeholder), 9, S),
        p("div", H, [
          q(p("input", {
            role: "textbox",
            class: "thn--tool-input__input",
            ref_key: "inputRef",
            ref: r,
            dir: "auto",
            required: e.required,
            disabled: e.disabled,
            type: e.type || "email",
            name: e.type || "email",
            id: e.id,
            error: (a = t.value) == null ? void 0 : a.showing,
            placeholder: e.placeholder,
            "onUpdate:modelValue": i[0] || (i[0] = (_) => l.value = _),
            onMousedown: g,
            "aria-label": e.placeholder,
            "aria-live": "assertive"
          }, null, 40, P), [
            [x, l.value]
          ]),
          (c = t.value) != null && c.showing ? (v(), D(m(z), {
            key: 0,
            class: "absolute right-2 top-1/2 transform -translate-y-1/2 text-danger-500 w-5 h-5 pointer-events-none"
          })) : L("", !0)
        ])
      ], 512);
    };
  }
});
export {
  X as _
};
//# sourceMappingURL=Input.vue_vue_type_style_index_0_lang.DQh55wuO.js.map
